"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _disrupt = _interopRequireDefault(require("@ux/disrupt"));

const _excluded = ["children", "show"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

const UX_MESSAGE_OVERLAY_CLASSNAME = 'ux-message-overlay';
/**
 * <MessageOverlay/> component, props are inherited from <Disrupt/>
 *
 * @param {Object} props - Component props
 * @returns {Component} <MessageOverlay/>
 */

function MessageOverlay(props) {
  const {
    children,
    show
  } = props,
        rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  if (typeof show !== 'undefined' && !show) return null;
  return /*#__PURE__*/_react.default.createElement(_disrupt.default, rest, /*#__PURE__*/_react.default.createElement("div", {
    className: `${UX_MESSAGE_OVERLAY_CLASSNAME}-content`
  }, children));
}

MessageOverlay.propTypes = _objectSpread({}, _disrupt.default.propTypes);
var _default = MessageOverlay;
exports.default = _default;